<template>
  <div>
    <base-header class="pb-8 pt-3">
      <!-- Card stats -->
      <b-row>
        <b-col md="3"></b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="12">
          <b-alert variant="danger" show v-if="error.length">
            <p class="mb-0" v-for="(err, k) in error" :key="k">{{ err }}</p>
          </b-alert>
          <b-card no-title class="shadow">
            <template #header>
              <div class="d-flex justify-content-between">
                <h3 class="mb-0">Información de la Sucursal</h3>
                <b-button
                  @click="save"
                  :disabled="working"
                  variant="primary"
                  size="sm"
                  >Guardar</b-button
                >
              </div>
            </template>
            <div class="row">
              <div class="col-md-3 mb-2">
                <label for="">Nombre Sucursal</label>
                <input
                  v-model="element.nombre"
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                />
              </div>
              <div class="col-md-3 mb-2">
                <label for="">RFC</label>
                <input
                  v-model="element.rfc"
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                />
              </div>
              <div class="col-md-4 mb-2">
                <label for="">Razón Social</label>
                <input
                  v-model="element.razon_social"
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                />
              </div>
              <div class="col-md-2 mb-2">
                <label for="">Tipo Sociedad</label>
                <input
                  v-model="element.sociedad_tipo"
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                  placeholder="SA DE CV"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-2">
                <label for="">Régimen Fiscal</label>
                <select
                  v-model="element.regimen_fiscal"
                  name=""
                  id=""
                  class="form-control form-control-sm form-control-solid"
                >
                  <option value="601">General de Ley Personas Morales</option>
                  <option value="612">
                    Personas Físicas con Actividades Empresariales y
                    Profesionales
                  </option>
                  <option value="621">Incorporación Fiscal</option>
                </select>
              </div>
              <div class="col-md-3 mb-2">
                <label for="">Código Postal Emisor</label>
                <input
                  v-model="element.codigo_postal"
                  type="number"
                  class="form-control form-control-sm form-control-solid"
                />
              </div>
              <div
                class="col-md-3 mb-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Ej: Tepic -1, Cancún 1"
              >
                <label for=""
                  >Diferencia Horaria
                  <i class="fas fa-question-circle"></i>
                  <span class="badge badge-danger ml-2">{{
                    element.dif_horaria
                  }}</span></label
                >
                <input
                  v-model="element.dif_horaria"
                  type="range"
                  class="custom-range"
                  min="-2"
                  max="2"
                  step="1"
                  id="customRange3"
                />
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="12">
          <b-card no-title class="mt-2 shadow">
            <template #header>
              <div class="d-flex justify-content-between">
                <h3 class="mb-0">Parámetros Facturación</h3>
                <b-button
                  @click="save"
                  :disabled="working"
                  variant="primary"
                  size="sm"
                  >Guardar</b-button
                >
              </div>
            </template>
            <div class="row">
              <div class="col-md-3">
                <div class="custom-control custom-switch shadow-none pointer">
                  <input
                    v-model="element.cancel"
                    :true-value="0"
                    :false-value="1"
                    type="checkbox"
                    class="custom-control-input"
                    id="activa"
                    name="example"
                  />
                  <label class="custom-control-label" for="activa"
                    >Activa</label
                  >
                </div>
              </div>
              <div class="col-md-3">
                <div class="custom-control custom-switch shadow-none pointer">
                  <input
                    v-model="element.factura_global"
                    :true-value="1"
                    :false-value="0"
                    type="checkbox"
                    class="custom-control-input"
                    id="factura_global"
                    name="example"
                  />
                  <label class="custom-control-label" for="factura_global"
                    >Factura Global</label
                  >
                </div>
              </div>
              <hr class="my-3" />
              <div class="col-md-8">
                <label for="">Serie Tickets ICG</label>
                <div class="d-flex">
                  <input
                    :disabled="working || !element.id"
                    ref="inputSeriePublic"
                    type="text"
                    class="form-control form-control-sm form-control-solid"
                    placeholder="Ej: T001"
                  />
                  <input
                    @keyup.enter="serieAgregar"
                    :disabled="working || !element.id"
                    ref="inputSerie"
                    type="text"
                    class="form-control form-control-sm form-control-solid"
                    placeholder="Ej: AB1"
                  />
                  <button
                    @click="serieAgregar"
                    class="btn btn-sm btn-icon btn-primary"
                  >
                    +
                  </button>
                </div>
                <table class="table table-bordered table-sm table-hover">
                  <tbody>
                    <tr v-for="(item, ks) in element.series" :key="ks">
                      <td>{{ item.serie_public }}</td>
                      <td>{{ item.serie }}</td>
                      <td class="text-right pt-1">
                        <button-delete @onDelete="serieEliminar(item)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <small>Activas: </small> -->
                <!-- <template v-for="(item, ks) in element.series">
                  <b-badge
                    v-if="!item.cancel"
                    :key="ks"
                    @dblclick="serieEliminar(item)"
                    variant="primary"
                    class="mr-1 noselect"
                    >{{ item.serie_public }}|{{ item.serie }}</b-badge
                  >
                </template> -->
              </div>
            </div>
            <!-- <hr class="my-2" /> -->
            <div class="row mt-2">
              <div class="col-md-3">
                <label for="">Serie CFDI</label>
                <input
                  v-model="element.serie"
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                  placeholder="Ejemplo: AA"
                />
              </div>
            </div>
            <!-- <hr class="my-2" /> -->
            <div v-if="element.id" class="row mt-3">
              <div class="col">
                <h4>Sello almacenado con el PAC</h4>
                <table v-if="getSelloByRFC(element.rfc)" class="table table-sm">
                  <thead class="bg-secondary text-white">
                    <tr>
                      <th class="py-1">RFC</th>
                      <th class="py-1">No. Certificado</th>
                      <th class="py-1 text-center">Inicio Vigencia</th>
                      <th class="py-1 text-center">Fin Vigencia</th>
                      <th class="py-1 text-center">Días Restantes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ getSelloByRFC(element.rfc).issuer_rfc }}
                      </td>
                      <td>
                        {{ getSelloByRFC(element.rfc).certificate_number }}
                      </td>
                      <td class="text-center">
                        {{
                          moment(getSelloByRFC(element.rfc).valid_from).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                      </td>
                      <td class="text-center">
                        {{
                          moment(getSelloByRFC(element.rfc).valid_to).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                      </td>
                      <th class="text-center">
                        {{
                          moment(getSelloByRFC(element.rfc).valid_to).diff(
                            moment(),
                            "days"
                          )
                        }}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div v-if="element.sello" class="col-md-6 mt-2">
                <label for="">No. Certificado</label>
                <input
                  :value="element.sello.sello_no"
                  disabled
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                />
              </div>
              <div v-if="element.sello" class="col-md-3 mt-2">
                <label for="">Vigencia</label>
                <input
                  :value="
                    moment(element.sello.sello_vigencia).format(
                      'DD-MM-YYYY HH:mm'
                    )
                  "
                  disabled
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                />
              </div>
              <div v-if="element.sello" class="col-md-3 mt-2">
                <label for="">Vencimiento</label>
                <input
                  :value="
                    moment(element.sello.sello_vencimiento).format(
                      'DD-MM-YYYY HH:mm'
                    )
                  "
                  disabled
                  type="text"
                  class="form-control form-control-sm form-control-solid"
                />
              </div>
              <div class="col-md-12 text-right">
                <b-button
                  @click="selloModal"
                  variant="primary"
                  size="sm"
                  class="mt-3"
                  :disabled="working"
                  >Actualizar Sello</b-button
                >
              </div> -->
            </div>
          </b-card>
        </b-col>
        <b-col md="12">
          <b-card no-title class="mt-2 shadow">
            <template #header>
              <div class="d-flex justify-content-between">
                <h3 class="mb-0">Empleados</h3>
                <!-- <button class="btn btn-primary btn-sm">Agregar</button> -->
                <AttachToBranch
                  :branchId="parseInt($route.params.id)"
                  @onAttach="getSucursal"
                />
              </div>
            </template>
            <div class="row">
              <div class="col">
                <table
                  class="getting table align-items-center table-flush table-sm table-hover"
                >
                  <thead class="thead-light">
                    <tr
                      class="fw-bold fs-7 text-gray-500 border-bottom border-gray-200 py-4"
                    >
                      <!-- <th>Role</th> -->
                      <th>Nombre</th>
                      <!-- <th>Email</th> -->
                      <!-- <th>Foto</th> -->
                      <th class="w-25"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(empleado, ku) in element.empleados" :key="ku">
                      <!-- <td>{{ empleado.UserSucursal.role }}</td> -->
                      <td>{{ empleado.nombre }}</td>
                      <!-- <td>{{ empleado.email }}</td> -->
                      <!-- <td></td> -->
                      <td class="text-right">
                        <ButtonDelete @onDelete="detachEmpleado(empleado)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <!-- MODAL UPDATE SELLO -->
    <!-- <b-modal id="modal-sello" title="Actualizar Sello">
      <b-form-group label="Certificado">
        <b-form-file
          :disabled="working"
          type="file"
          id="formCer"
          ref="formCer"
          accept=".cer"
          class="form-control-sm form-control-solid"
        ></b-form-file>
      </b-form-group>
      <b-form-group label="Llave">
        <b-form-file
          :disabled="working"
          type="file"
          id="formKey"
          ref="formKey"
          accept=".key"
          class="form-control-sm form-control-solid"
        ></b-form-file>
      </b-form-group>
      <b-form-group>
        <div class="mb-2">
          Contraseña
          <i
            v-if="showPass"
            class="far fa-eye text-danger"
            @click="showPass = false"
          ></i>
          <i
            v-if="!showPass"
            class="far fa-eye-slash"
            @click="showPass = true"
          ></i>
        </div>
        <b-form-input
          :disabled="working"
          type="password"
          id="formPass"
          ref="formPass"
          class="form-control-sm form-control-solid"
        ></b-form-input>
      </b-form-group>
      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <b-button variant="dark" @click="selloCancelar()"> Cancel </b-button>
          <b-button
            variant="success"
            @click="selloActualizar()"
            :disabled="working"
          >
            Actualizar
          </b-button>
        </div>
      </template>
    </b-modal> -->
  </div>
</template>
<script>
import moment from "moment";
import ButtonDelete from "@/components/IDBRICS/tools/ButtonDelete";
import AttachToBranch from "@/components/IDBRICS/Users/AttachToBranch.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ButtonDelete,
    AttachToBranch,
  },
  data() {
    return {
      moment: moment,
      working: false,
      error: [],
      element: {},
      old: {},
      schema: {
        id: "",
        codigo: "",
        nombre: "",
        razon_social: "",
        sociedad_tipo: "",
        rfc: "",
        regimen_fiscal: "",
        codigo_postal: "",
        domicilio: "",
        serie: "",
        factura_global: 0,
        dif_horaria: "",
        empresa_id: "",
        cancel: 0,
        series: [],
        sello: {
          sello_no: "",
          sello_vigencia: "",
          sello_vencimiento: "",
        },
      },
      series: [],
      sello: {
        sello_no: "",
        sello_vigencia: "",
        sello_vencimiento: "",
      },
      selloForm: {
        cer: null,
        key: null,
      },
      showPass: false,
    };
  },
  computed: {
    ...mapGetters(["getSelloByRFC"]),
  },
  watch: {
    showPass: function (val) {
      if (val) {
        this.$refs.formPass.$el.type = "text";
      } else {
        this.$refs.formPass.$el.type = "password";
      }
    },
  },
  created() {
    if (this.$route.params.id > 0 && this.$route.params.id != "nuevo") {
      this.getSucursal();
    } else {
      this.restartSchema();
    }
  },
  methods: {
    getSucursal() {
      this.working = true;

      this.$api
        .get(`/sucursales/${this.$route.params.id}`)
        .then((res) => {
          this.element = res.data;
          // this.getSeries()
        })
        .catch((e) => console.log(e))
        .then(() => {
          this.working = false;
        });
    },
    // getSeries(){
    //   this.working = true

    //   this.$api
    //   .get(`/sucursales/${this.$route.params.id}/series`)
    //   .then(res => {
    //     this.series = res.data
    //   })
    //   .catch(e => this.error.push(e.response.data.error.message))
    //   .then(()=> {
    //     this.working = false
    //   })
    // },
    restartSchema() {
      this.element = JSON.parse(JSON.stringify(this.schema));
    },
    save() {
      if (this.element.id > 0 && this.element.id != "nuevo") {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      this.working = true;

      if (this.validations()) {
        this.working = false;
        return;
      }

      this.$api
        .post(`/sucursales/`, this.element)
        .then((res) => {
          this.$notiflix.Notify.success("Registro Creado");
          this.element = res.data;
          this.$router.push({ path: `/catalogos/sucursales/${res.data.id}` });
        })
        .catch((e) => this.error.push(e.response.data.error.message))
        .then(() => (this.working = false));
    },
    update() {
      this.working = true;

      if (this.validations()) {
        return;
      }

      this.$api
        .put(`/sucursales/${this.element.id}`, this.element)
        .then((res) => {
          this.$notiflix.Notify.success("Registro Actualizado");
          this.element = res.data;
        })
        .catch((e) => this.error.push(e.response.data.error.message))
        .then(() => (this.working = false));
    },
    validations() {
      this.error = [];

      if (!this.element.nombre) {
        this.error.push("El campo [NOMBRE] no puede estar vacío");
      }
      if (!this.element.razon_social) {
        this.error.push("El campo [RAZON SOCIAL] no puede estar vacío");
      }
      if (!this.element.rfc) {
        this.error.push("El campo [RFC] no puede estar vacío");
      }
      if (!this.element.regimen_fiscal) {
        this.error.push("El campo [Régimen Fiscal] no puede estar vacío");
      }
      if (!this.element.codigo_postal) {
        this.error.push("El campo [Código Postal] no puede estar vacío");
      }
      if (!this.element.serie) {
        this.error.push("El campo [Serie CFDI] no puede estar vacío");
      }

      return this.error.length;
    },
    serieAgregar() {
      this.working = true;

      let serie = this.$refs.inputSerie.value;
      let serie_public = this.$refs.inputSeriePublic.value;

      if (serie == "" || serie_public == "") {
        this.$notiflix.Notify.failure(
          "Verifique los parámetros de la SERIE ICG"
        );
        this.working = false;
        return;
      }

      this.$api
        .post("/sucursales/series/", {
          sucursal_id: this.element.id,
          serie,
          serie_public,
        })
        .then((res) => {
          this.$notiflix.Notify.success("Serie Agregada");
          this.element.series.push(res.data);
        })
        .catch((e) => this.error.push(e))
        .then(() => {
          this.$refs.inputSerie.value = "";
          this.$refs.inputSeriePublic.value = "";
          this.working = false;
        });
    },
    serieEliminar(serie) {
      this.working = true;

      this.$api
        .delete(`/sucursales/series/${serie.id}`)
        .then((res) => {
          this.element.series.find((item, index) => {
            console.log(serie, item);
            if (item.id == serie.id) {
              this.element.series.splice(index, 1);
              this.$notiflix.Notify.success("Registro Eliminado");
            }
          });
        })
        .catch((e) => {
          // this.error.push(e.response.data.error.message)
          console.log(e);
          this.error.push(e);
        })
        .then(() => {
          this.working = false;
        });
    },
    selloModal() {
      this.$bvModal.show("modal-sello");
    },
    selloCancelar() {
      this.$bvModal.hide("modal-sello");
    },
    selloActualizar() {
      console.log("selloActualizar");
      // let cer = this.$refs.formCer.files[0];
      // let key = this.$refs.formKey.files[0];
      // let pass = this.$refs.formPass.$el.value;

      let cer = document.getElementById("formCer");
      let key = document.getElementById("formKey");
      let pass = document.getElementById("formPass");

      if (cer == undefined || key == undefined) {
        this.$notiflix.Notify.failure("Seleccione Certificado y LLave");
        return;
      }

      let formData = new FormData();
      formData.append("cer", cer);
      formData.append("key", key);
      formData.append("pass", pass);

      this.$api
        .post(`/sucursales/${this.element.id}/sello`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.selloCancelar();
          this.element.sello = res.data;
          this.$notiflix.Notify.success("Sello actualizado correctamente.");
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            "Verifique los archivos/contraseña, sello no guardado."
          );
          console.log("FAILURE!!");
        });
    },
    detachEmpleado(empleado) {
      this.working = true;

      this.$api
        .delete(`/sucursales/${this.element.id}/empleados/${empleado.id}`)
        .then((res) => {
          this.$notiflix.Notify.success("Registro Actualizado");
          this.getSucursal();
        })
        .catch((e) => this.error.push(e.response.data.error.message))
        .then(() => (this.working = false));
    },
  },
};
</script>
